import {formatMoney} from 'lib/formatters';
import {ProductsGridTotals} from 'modules/ProductsGrid/lib/types';
import {FC} from 'react';

import styles from './GridFooter.module.css';

type Props = {
    totals: ProductsGridTotals;
};
export const GridFooter: FC<Props> = ({totals}) => {
    const priceIsChanged =
        totals.summary.price.old !== totals.summary.price.current;

    return (
        <div className={styles.footer}>
            <div className={styles.footerTitle}>
                Итого
                <span>{totals.summary.count}</span>
            </div>
            <div className={styles.footerDescription}>
                Стоимость комплекта оборудования ({totals.summary.count}{' '}
                наименований)
            </div>
            <div className={styles.footerTotal}>
                {priceIsChanged && (
                    <div className={styles.footerPriceOld}>
                        {formatMoney(totals.summary.price.old)}
                    </div>
                )}
                <div className={styles.footerPriceCurrent}>
                    {formatMoney(totals.summary.price.current)}
                </div>
            </div>
        </div>
    );
};
